import React from "react";
import { FaUser } from "react-icons/fa";
const DataContext = React.createContext();
export const useData = () => React.useContext(DataContext);
const DataProvider = ({ children }) => {
  const user = {
    name: "John Doe",
    icon: <FaUser />,
  };

  const stats = [
    {
      title: "Active Memberships",
      value: 1200,
      change: 10,
    },
    {
      title: "Revenue",
      value: 35000,
      change: -5,
    },
    {
      title: "Support Requests",
      value: 240,
      change: 15,
    },
    {
      title: "Connect Hours",
      value: 800,
      change: 20,
    },
  ];
  const barChartData = [
    { name: "Jan", revenue: 400 },
    { name: "Feb", revenue: 300 },
    { name: "Mar", revenue: 500 },
    { name: "Apr", revenue: 600 },
    { name: "May", revenue: 800 },
  ];

  const lineChartData = [
    { name: "Jan", value: 10 },
    { name: "Feb", value: 20 },
    { name: "Mar", value: 30 },
    { name: "Apr", value: 25 },
    { name: "May", value: 40 },
  ];

  const pieChartData = [
    { name: "Group A", value: 400 },
    { name: "Group B", value: 300 },
    { name: "Group C", value: 300 },
  ];

  const userData = [
    {
      id: 1,
      name: "Jane Doe",
      dob: "1990-01-01",
      state: "California",
      joinDate: "2022-01-01",
      membership: "Premium",
    },
    {
      id: 2,
      name: "John Smith",
      dob: "1985-02-15",
      state: "New York",
      joinDate: "2021-06-15",
      membership: "Basic",
    },
    {
      id: 3,
      name: "Alice Johnson",
      dob: "1993-03-20",
      state: "Texas",
      joinDate: "2020-11-05",
      membership: "Premium",
    },
    {
      id: 4,
      name: "Bob Williams",
      dob: "1980-12-12",
      state: "Florida",
      joinDate: "2021-01-20",
      membership: "Basic",
    },
    {
      id: 5,
      name: "Charlie Brown",
      dob: "1999-04-25",
      state: "Washington",
      joinDate: "2022-03-01",
      membership: "Premium",
    },
    {
      id: 6,
      name: "Diana Davis",
      dob: "1988-06-05",
      state: "Oregon",
      joinDate: "2021-08-17",
      membership: "Basic",
    },
    {
      id: 7,
      name: "Eva Lopez",
      dob: "1995-10-30",
      state: "New Jersey",
      joinDate: "2021-10-01",
      membership: "Premium",
    },
    {
      id: 8,
      name: "Frank Martinez",
      dob: "1975-11-23",
      state: "Nevada",
      joinDate: "2021-02-12",
      membership: "Basic",
    },
    {
      id: 9,
      name: "Grace Turner",
      dob: "1992-07-14",
      state: "Arizona",
      joinDate: "2020-12-25",
      membership: "Premium",
    },
    {
      id: 10,
      name: "Henry White",
      dob: "1987-08-08",
      state: "Massachusetts",
      joinDate: "2021-05-10",
      membership: "Basic",
    },
    {
      id: 11,
      name: "Isla Lee",
      dob: "1991-09-19",
      state: "Michigan",
      joinDate: "2021-07-30",
      membership: "Premium",
    },
    {
      id: 12,
      name: "Jack Thomas",
      dob: "1994-05-01",
      state: "Georgia",
      joinDate: "2022-01-15",
      membership: "Basic",
    },
    {
      id: 13,
      name: "Kelly Clark",
      dob: "1996-03-28",
      state: "Virginia",
      joinDate: "2021-03-20",
      membership: "Premium",
    },
    {
      id: 14,
      name: "Lucas Robinson",
      dob: "1998-02-02",
      state: "Pennsylvania",
      joinDate: "2021-09-10",
      membership: "Basic",
    },
  ];

  const providerData = [
    {
      id: 1,
      name: "John Smith",
      type: "Individual",
      gender: "Male",
      state: "California",
      assignedUsers: 12,
    },
    {
      id: 2,
      name: "Jane Doe",
      type: "Company",
      gender: "Female",
      state: "Texas",
      assignedUsers: 8,
    },
    {
      id: 3,
      name: "Michael Johnson",
      type: "Individual",
      gender: "Male",
      state: "New York",
      assignedUsers: 20,
    },
    {
      id: 4,
      name: "Emily Williams",
      type: "Company",
      gender: "Female",
      state: "Florida",
      assignedUsers: 15,
    },
    {
      id: 5,
      name: "David Brown",
      type: "Individual",
      gender: "Male",
      state: "Pennsylvania",
      assignedUsers: 6,
    },
    {
      id: 6,
      name: "Sophia Jones",
      type: "Company",
      gender: "Female",
      state: "Illinois",
      assignedUsers: 10,
    },
    {
      id: 7,
      name: "James Davis",
      type: "Individual",
      gender: "Male",
      state: "Ohio",
      assignedUsers: 18,
    },
    {
      id: 8,
      name: "Charlotte Miller",
      type: "Company",
      gender: "Female",
      state: "Georgia",
      assignedUsers: 9,
    },
    {
      id: 9,
      name: "William Wilson",
      type: "Individual",
      gender: "Male",
      state: "North Carolina",
      assignedUsers: 14,
    },
    {
      id: 10,
      name: "Ava Taylor",
      type: "Company",
      gender: "Female",
      state: "Michigan",
      assignedUsers: 7,
    },
  ];

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

  const appointments = [
    {
      sessionId: "S001",
      date: "2023-05-05",
      user: "John Doe",
      provider: "Dr. Jane Smith",
      reason: "Cancelled by provider",
    },
    {
      sessionId: "S002",
      date: "2023-05-06",
      user: "Alice Johnson",
      provider: "Dr. Richard Brown",
      reason: "User rescheduled",
    },
    {
      sessionId: "S003",
      date: "2023-05-08",
      user: "Michael White",
      provider: "Dr. David Jones",
      reason: "Provider unavailable",
    },
    {
      sessionId: "S004",
      date: "2023-05-10",
      user: "Emily Taylor",
      provider: "Dr. Angela Martin",
      reason: "User requested cancellation",
    },
    {
      sessionId: "S005",
      date: "2023-05-12",
      user: "Daniel Anderson",
      provider: "Dr. Barbara Thompson",
      reason: "Provider rescheduled",
    },
    {
      sessionId: "S006",
      date: "2023-05-14",
      user: "Elizabeth Lee",
      provider: "Dr. Charles Harris",
      reason: "Cancelled by user",
    },
    {
      sessionId: "S007",
      date: "2023-05-16",
      user: "Matthew Clark",
      provider: "Dr. Patricia Lewis",
      reason: "User no-show",
    },
    {
      sessionId: "S008",
      date: "2023-05-18",
      user: "Laura Young",
      provider: "Dr. Sandra Hall",
      reason: "Cancelled by provider",
    },
    {
      sessionId: "S009",
      date: "2023-05-20",
      user: "David Allen",
      provider: "Dr. Michael Scott",
      reason: "User rescheduled",
    },
    {
      sessionId: "S010",
      date: "2023-05-22",
      user: "Linda Wright",
      provider: "Dr. Nancy King",
      reason: "Provider unavailable",
    },
  ];
  const supportRequests = [
    {
      requestId: "REQ-101",
      requestDate: "2023-05-01",
      type: "Technical",
      user: "John Doe",
      provider: "Jane Smith",
      closedRequest: true,
      openRequest: true,
    },
    {
      requestId: "REQ-102",
      requestDate: "2023-05-02",
      type: "Billing",
      user: "Alice Johnson",
      provider: "Robert Brown",
      closedRequest: true,
      openRequest: true,
    },
    {
      requestId: "REQ-103",
      requestDate: "2023-05-03",
      type: "General Inquiry",
      user: "Michael Jackson",
      provider: "Emily Davis",
      closedRequest: true,
      openRequest: false,
    },
    {
      requestId: "REQ-104",
      requestDate: "2023-05-04",
      type: "Technical",
      user: "Sarah Taylor",
      provider: "David Miller",
      closedRequest: true,
      openRequest: false,
    },
    {
      requestId: "REQ-105",
      requestDate: "2023-05-05",
      type: "Billing",
      user: "James Wilson",
      provider: "Sophia Moore",
      closedRequest: true,
      openRequest: true,
    },
    {
      requestId: "REQ-106",
      requestDate: "2023-05-06",
      type: "General Inquiry",
      user: "William Jones",
      provider: "Ava Thomas",
      closedRequest: true,
      openRequest: false,
    },
    {
      requestId: "REQ-107",
      requestDate: "2023-05-07",
      type: "Technical",
      user: "Elizabeth White",
      provider: "Isabella Jackson",
      closedRequest: true,
      openRequest: true,
    },
    {
      requestId: "REQ-108",
      requestDate: "2023-05-08",
      type: "Billing",
      user: "Henry Harris",
      provider: "Mia Lee",
      closedRequest: true,
      openRequest: true,
    },
    {
      requestId: "REQ-109",
      requestDate: "2023-05-09",
      type: "General Inquiry",
      user: "Alexander Lewis",
      provider: "Charlotte Hall",
      closedRequest: true,
      openRequest: false,
    },
    {
      requestId: "REQ-110",
      requestDate: "2023-05-10",
      type: "Technical",
      user: "Sebastian Young",
      provider: "Amelia Turner",
      closedRequest: true,
      openRequest: true,
    },
  ];
  const healthNavigators = [
    {
      userId: "USER-1",
      user: "John Doe",
      preference: "Female",
      requestDate: "2023-05-01",
    },
    {
      userId: "USER-2",
      user: "Jane Smith",
      preference: "Any",
      requestDate: "2023-05-02",
    },
    // Add more data as needed
  ];

  const healthCoaches = [
    {
      userId: "COACH-1",
      user: "Alice Johnson",
      focus: "Nutrition",
      requestDate: "2023-05-01",
    },
    {
      userId: "COACH-2",
      user: "Robert Brown",
      focus: "Fitness",
      requestDate: "2023-05-02",
    },
    // Add more data as needed
  ];
  const healthNavigatorss = [
    {
      userId: "USER-1",
      user: "John Doe",
      preference: "Lack of Engagement",
      requestDate: "2023-05-01",
    },
    {
      userId: "USER-2",
      user: "Jane Smith",
      preference: "Lack of Engagement",
      requestDate: "2023-05-02",
    },
    // Add more data as needed
  ];

  const healthCoachess = [
    {
      userId: "COACH-1",
      user: "Alice Johnson",
      focus: "Lack of Engagement",
      requestDate: "2023-05-01",
    },
    {
      userId: "COACH-2",
      user: "Robert Brown",
      focus: "Lack of Engagement",
      requestDate: "2023-05-02",
    },
    // Add more data as needed
  ];

  const businessData = [
    {
      id: "B1",
      name: "Business One",
      state: "California",
      plan: "Basic",
      activeUsers: 50,
      status: "Active",
    },
    {
      id: "B2",
      name: "Business Two",
      state: "New York",
      plan: "Premium",
      activeUsers: 75,
      status: "Active",
    },
    {
      id: "B3",
      name: "Business Three",
      state: "Texas",
      plan: "Enterprise",
      activeUsers: 150,
      status: "Active",
    },
    {
      id: "B4",
      name: "Business Four",
      state: "Florida",
      plan: "Basic",
      activeUsers: 30,
      status: "Inactive",
    },
    {
      id: "B5",
      name: "Business Five",
      state: "Illinois",
      plan: "Premium",
      activeUsers: 90,
      status: "Active",
    },
    {
      id: "B6",
      name: "Business Six",
      state: "Washington",
      plan: "Enterprise",
      activeUsers: 200,
      status: "Active",
    },
    {
      id: "B7",
      name: "Business Seven",
      state: "Georgia",
      plan: "Basic",
      activeUsers: 40,
      status: "Inactive",
    },
    {
      id: "B8",
      name: "Business Eight",
      state: "Michigan",
      plan: "Premium",
      activeUsers: 80,
      status: "Active",
    },
    {
      id: "B9",
      name: "Business Nine",
      state: "Arizona",
      plan: "Enterprise",
      activeUsers: 175,
      status: "Active",
    },
    {
      id: "B10",
      name: "Business Ten",
      state: "New Jersey",
      plan: "Basic",
      activeUsers: 20,
      status: "Inactive",
    },
  ];
  const sampleMemberships = [
    {
      plan: "Basic",
      price: 49,
      connectHours: 5,
      validityDays: 30,
      type: "Individual",
      creationDate: "2023-02-01",
    },
    {
      plan: "Premium",
      price: 99,
      connectHours: 15,
      validityDays: 30,
      type: "Individual",
      creationDate: "2023-02-01",
    },
    {
      plan: "Family",
      price: 149,
      connectHours: 20,
      validityDays: 30,
      type: "Family",
      creationDate: "2023-02-01",
    },
    {
      plan: "Business",
      price: 299,
      connectHours: 50,
      validityDays: 30,
      type: "Business",
      creationDate: "2023-02-01",
    },
    {
      plan: "Enterprise",
      price: 999,
      connectHours: 200,
      validityDays: 30,
      type: "Business",
      creationDate: "2023-02-01",
    },
  ];
  const memberData = [
    {
      id: 1,
      name: "John Doe",
      email: "john.doe@example.com",
      phoneNumber: "123-456-7890",
      role: "Member",
      joinDate: "2022-01-15",
      status: "Active",
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane.smith@example.com",
      phoneNumber: "234-567-8901",
      role: "HR",
      joinDate: "2022-02-10",
      status: "Active",
    },
    {
      id: 3,
      name: "Alice Johnson",
      email: "alice.johnson@example.com",
      phoneNumber: "345-678-9012",
      role: "Super Admin",
      joinDate: "2021-12-20",
      status: "Inactive",
    },
    // Add more members as needed
  ];
  const roleData = [
    {
      id: 1,
      name: "Member",
    },
    {
      id: 2,
      name: "HR",
    },
    {
      id: 3,
      name: "Super Admin",
    },
    {
      id: 4,
      name: "Team Lead",
    },
    {
      id: 5,
      name: "Project Manager",
    },
    {
      id: 6,
      name: "Developer",
    },
    {
      id: 7,
      name: "Designer",
    },
    {
      id: 8,
      name: "Marketing",
    },
    {
      id: 9,
      name: "Customer Support",
    },
  ];

  return (
    <DataContext.Provider
      value={{
        user,
        stats,
        barChartData,
        userData,
        lineChartData,
        pieChartData,
        providerData,
        COLORS,
        appointments,
        supportRequests,
        healthNavigators,
        healthCoaches,
        healthNavigatorss,
        healthCoachess,
        businessData,
        sampleMemberships,
        memberData,
        roleData,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export default DataProvider;
